import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Home } from "lucide-react";
import { ChevronRight } from "../components/DirectionalIcon";

const NotFoundPage = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("notFound.meta.title");

    let metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      metaRobots = document.createElement("meta");
      metaRobots.name = "robots";
      document.head.appendChild(metaRobots);
    }
    metaRobots.setAttribute("content", "noindex, nofollow");
  }, [t]);

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4 py-32">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-lg"
        data-testid="404-page"
      >
        <p className="text-gold text-sm uppercase tracking-[0.3em] font-semibold mb-4">
          {t("notFound.errorLabel")}
        </p>
        <h1 className="font-outfit text-4xl sm:text-5xl font-bold text-white mb-6">
          {t("notFound.title")}
        </h1>
        <p className="text-slate-300 text-lg mb-10">
          {t("notFound.description")}
        </p>
        <Link
          to="/"
          data-testid="404-home-link"
          className="inline-flex items-center justify-center gap-2 bg-gold text-navy px-8 py-4 text-xs font-bold uppercase tracking-widest hover:bg-gold-light transition-colors"
        >
          <Home size={16} />
          {t("notFound.homeLink")}
          <ChevronRight size={16} />
        </Link>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;
